import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LineChartOptions } from '../../components/GraphQL/LineChart/linechart.component';
import { PieChartOptions } from '../../components/GraphQL/PieChart/piechart.component';
import { UserPopUpComponent } from '../../components/user-pop-up/user-pop-up.component';
import { Router } from '@angular/router';
import { DialogComponent } from '../../components/dialog/dialog.component';

import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, combineLatest, interval, NEVER, Observable, ReplaySubject } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import * as d3 from "d3";
import { StackedBarChartOptions } from '../../components/GraphQL/StackedBarChartPagination/stackedbarchartpagination.component';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLFilter, GraphQLGroupBy, GraphQlQuery, GraphQlResultsSeriesOptions, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';




export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'dashboardstandard1',
  templateUrl: './dashboardstandard1.component.html',
  styleUrls: ['./dashboardstandard1.component.css']
})
export class DashboardStandard1Component implements OnInit {

  @ViewChild('EveCdrsDialogTemplate') eveCdrsDialogTemplate: TemplateRef<any>;

  document = document;
  scale: number = 1.5;

  showTotalPlacedCalls: boolean = true;
  showTotalDuration: boolean = true;
  showCallsByUser: boolean = true;
  showCallsByDestination: boolean = true;

  object = Object;

  minStartDate: Observable<Date> = interval(60000).pipe(
    startWith(null),
    map(() => {
      const minStartDate = new Date();
      minStartDate.setMonth(minStartDate.getMonth() - 3);
      if (minStartDate > new Date('2022-07-19')) {
        return minStartDate;
      }
      else {
        return new Date('2022-07-19');
      }
    })
  );

  menuOpened: boolean = true;

  
  startDate: ReplaySubject<Date> = new ReplaySubject<Date>();
  endDate: ReplaySubject<Date> = new ReplaySubject<Date>();
  //startDate: BehaviorSubject<String> = new BehaviorSubject<String>("now/M");
  //endDate: BehaviorSubject<String> = new BehaviorSubject<String>("now/M+8d");

  

  company: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  whereObservable: Observable<GraphQLFilter[]> = combineLatest(
    this.startDate,
    this.endDate.pipe(
      map(d => {
        d?.setHours(23);
        d?.setMinutes(59);
        d?.setSeconds(59);
        d?.setMilliseconds(999);
        return d;
      })
    ),
    this.company)
    .pipe(
      map(([startDate, endDate, company]) => {
        return [
          {
            path: "startTime",
            comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL,
            value: startDate
          } as GraphQLFilter,
          {
            path: "startTime",
            comparison: GraphQLComparision.LESS_THAN_OR_EQUAL,
            value: endDate
          } as GraphQLFilter,
          {
            path: "companyOrganisationNode",
            comparison: GraphQLComparision.EQUAL,
            value: company?.organisationNode ?? null
          } as GraphQLFilter
        ] as GraphQLFilter[];
      })
  );





  totalPlacedCallsOptions: LineChartOptions = {
    width: 2000,
    height: 800,
    chartHeader: "Total Placed Calls",
    xAxisLabel: "Hour/Day",
    yAxisLabel: "Total Calls",
    xAxisTickFormatting: multiFormat,
    colourScheme: null
  };
  totalPlacedCalls_HourQuery: Observable<GraphQlQuery> = this.whereObservable.pipe(
    map(w => ({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "count",
          arguments: null
        },
        {
          field: "eveCdrCallType",
          arguments: null
        },
        {
          field: "startTime",
          arguments: null
        }
      ],
      wheres: w,
      groupBys: [{ path: "startTime", timeUnit: "HOURS" } as GraphQLGroupBy, { path: "eveCdrCallType" } as GraphQLGroupBy],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );
  totalPlacedCalls_DayQuery: Observable<GraphQlQuery> = this.whereObservable.pipe(
    map(w => ({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "count",
          arguments: null
        },
        {
          field: "eveCdrCallType",
          arguments: null
        },
        {
          field: "startTime",
          arguments: null
        }
      ],
      wheres: w,
      groupBys: [{ path: "startTime", timeUnit: "DAYS" } as GraphQLGroupBy, { path: "eveCdrCallType" } as GraphQLGroupBy],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );


  totalDurationOptions: LineChartOptions = {
    width: null,
    height: null,
    chartHeader: "Total Duration",
    xAxisLabel: "Hour/Day",
    yAxisLabel: "Minutes",
    xAxisTickFormatting: multiFormat,
    colourScheme: null
  };
  totalDurationResultsSeriesOptions: GraphQlResultsSeriesOptions = {
    nameTemplate: null,
    valueConverter: v => v / 60
  };
  totalDuration_HourQuery : Observable<GraphQlQuery> = this.whereObservable.pipe(
    map(w => ({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "duration",
          arguments: null
        },
        {
          field: "eveCdrCallType",
          arguments: null
        },
        {
          field: "startTime",
          arguments: null
        }
      ],
      wheres: w,
      groupBys: [{ path: "startTime", timeUnit: "HOURS" } as GraphQLGroupBy, { path: "eveCdrCallType" } as GraphQLGroupBy],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );
  totalDuration_DayQuery: Observable<GraphQlQuery> = this.whereObservable.pipe(
    map(w => ({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "duration",
          arguments: null
        },
        {
          field: "eveCdrCallType",
          arguments: null
        },
        {
          field: "startTime",
          arguments: null
        }
      ],
      wheres: w,
      groupBys: [{ path: "startTime", timeUnit: "DAYS" } as GraphQLGroupBy, { path: "eveCdrCallType" } as GraphQLGroupBy],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );

  callsByUser_selectedUsers: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  callsByUser_extraWheres: Observable<GraphQLFilter[]> = this.callsByUser_selectedUsers.pipe(
    map(eveUsers => {
      if (eveUsers == null || eveUsers.length == 0) return <GraphQLFilter[]>[];

      return <GraphQLFilter[]>[
        //{ path: "ownerTypeId", comparison: GraphQLComparision.EQUAL, value: "0" },
        { path: "ownerId", comparison: GraphQLComparision.IN, value: eveUsers.map(eveuser => eveuser.eveUserId) } as GraphQLFilter
      ];
    })
  );

  callsByUserOptions: StackedBarChartOptions = {
    width: 1000,
    height: 400,
    chartHeader: "Calls by User",
    xAxisLabel: "Eve User",
    yAxisLabel: "Minutes/Quantity",
    colourScheme: null
  };
  callsByUser_MinutesGraphQlResultsSeriesOptions: GraphQlResultsSeriesOptions = {
    nameTemplate: "${this.owner}",
    valueConverter : v => v/60
  };
  callsByUser_MinutesQuery: Observable<GraphQlQuery> = combineLatest(this.whereObservable, this.callsByUser_extraWheres).pipe(
    map(([wheres, extraWheres]) => ({
      dataset: "eveCdrOwnersPage",
      selects: [
        {
          field: "duration",
          arguments: null
        },
        {
          field: "ownerTypeId",
          arguments: null
        },
        {
          field: "ownerId",
          arguments: null
        },
        {
          field: "owner",
          arguments: null
        },
        {
          field: "eveCdrCallType",
          arguments: null
        }
      ],
      wheres: wheres.concat(extraWheres),
      groupBys: [
        { path: "eveCdrCallType" } as GraphQLGroupBy,
        { path: "ownerTypeId" } as GraphQLGroupBy,
        { path: "ownerId" } as GraphQLGroupBy
      ],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );

  callsByUser_QuantityGraphQlResultsSeriesOptions: GraphQlResultsSeriesOptions = {
    nameTemplate: "${this.owner}",
    valueConverter: null
  };
  callsByUser_QuantityQuery: Observable<GraphQlQuery> = combineLatest(this.whereObservable, this.callsByUser_extraWheres).pipe(
    map(([wheres, extraWheres]) => ({
      dataset: "eveCdrOwnersPage",
      selects: [
        {
          field: "count",
          arguments: null
        },
        {
          field: "ownerTypeId",
          arguments: null
        },
        {
          field: "ownerId",
          arguments: null
        },
        {
          field: "owner",
          arguments: null
        },
        {
          field: "eveCdrCallType",
          arguments: null
        }
      ],
      wheres: wheres.concat(extraWheres),
      groupBys: [
        { path: "eveCdrCallType" } as GraphQLGroupBy,
        { path: "ownerTypeId" } as GraphQLGroupBy,
        { path: "ownerId" } as GraphQLGroupBy
      ],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );


  callsByDestinationOptions: PieChartOptions = {
    width: 4000,
    height: 400,
    chartHeader: "Calls by Destination"
  };
  callsByDestination_MinutesResultsSeriesOptions: GraphQlResultsSeriesOptions = {
    nameTemplate: null,
    valueConverter: v => v / 60
  };
  callsByDestination_MinutesQuery: Observable<GraphQlQuery> = this.whereObservable.pipe(
    map(w => ({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "duration",
          arguments: null
        },
        {
          field: "callDestination",
          arguments: null
        }
      ],
      wheres: w.concat([{ path: "callDestination", comparison: GraphQLComparision.NOT_EQUAL, value: null } as GraphQLFilter]),
      groupBys: [{ path: "callDestination" } as GraphQLGroupBy],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );
  callsByDestination_QuantityQuery: Observable<GraphQlQuery> = this.whereObservable.pipe(
    map(w => ({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "count",
          arguments: null
        },
        {
          field: "callDestination",
          arguments: null
        }
      ],
      wheres: w.concat([{ path: "callDestination", comparison: GraphQLComparision.NOT_EQUAL, value: null } as GraphQLFilter]),
      groupBys: [{ path: "callDestination" } as GraphQLGroupBy],
      orderBy: [],
      page: 0,
      pageSize: -1
    }))
  );



  expandedElement: Element;


  constructor(
    public dialog: MatDialog,
    private router: Router,
    public graphQlService: IGraphQlService) {
      this.company.subscribe(() => this.callsByUser_selectedUsers.next([]))
    }

 


  myControl = new UntypedFormControl('');
  filteredOptions: Observable<AutoCompleteOption[]> = this.myControl.valueChanges.pipe(
    startWith(''),
    switchMap(v => {
      return this.graphQlService.getGraphQlResults({
        dataset: "companiesPage",
        selects: [
          {
            field: "name",
            arguments: null
          },
          {
            field: "organisationNode",
            arguments: null
          }
        ],
        wheres: [{ path: "name", comparison: GraphQLComparision.CONTAINS, value: v.name ?? v } as GraphQLFilter],
        groupBys: [],
        orderBy: [{ path: "name", descending: false }],
        page: 0,
        pageSize: 20
      })
    }),
    map(r => {
      return r.data.companiesPage.items.map(i => ({ name: i.name, value: i.organisationNode }))
    }),
    catchError(val => {
      
      return NEVER;
    })
  );



  ngOnInit() {
    const now = new Date();
    const midnightToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

    const startDate = new Date(midnightToday.getTime());
    startDate.setDate(startDate.getDate() - 30);

    if (startDate < new Date('2022-07-19')) this.startDate.next(new Date('2022-07-19'));
    else this.startDate.next(new Date(startDate));

    
    this.endDate.next(midnightToday);

    
  }

  autoCompleteOptionDisplayWith(option: AutoCompleteOption) {
    return option?.name ?? "";
  }


 


  selectGraph(event, dataset) {
    this.dialog.open(DialogComponent, {
      height: '75%',
      width: '75%',
      autoFocus: false,
      data: {
        header: "Calls",
        content: this.eveCdrsDialogTemplate,
        query: {
          dataset: event.query.dataset,
          selects: [
            {
              field: "eveCdrSourceId"
            },
            {
              field: "callId"
            },
            {
              field: "initialCallId"
            },
            {
              field: "eveCdrCallType"
            },
            {
              field: "startTime"
            },
            {
              field: "sourcePhoneNumber"
            },
            {
              field: "sourceOwner"
            },
            {
              field: "sourceOwnerTypeId"
            },
            {
              field: "sourceOwner"
            },
            {
              field: "sourceOwnerId"
            },
            {
              field: "targetPhoneNumber"
            }, 
            {
              field: "targetOwner"
            },
            {
              field: "targetOwnerTypeId"
            },
            {
              field: "targetOwnerId"
            },
            {
              field: "duration"
            }
          ],
          wheres: event.query.wheres.concat(event.result.wheres),
          orderBy: [{ path: "startTime", descending: true}]
        }
      },
    });
  }


  openCallsByUserSelectionDialog() {
    this.dialog.open(UserPopUpComponent, {
      data: {
        wheres: [{
          path: "endUserSiteNode",
          comparison: GraphQLComparision.IS_DESCENDANT_OF,
          value: this.company.value?.organisationNode ?? null
        }],
        selectedEveUsers: this.callsByUser_selectedUsers.value
      }
    }).afterClosed().subscribe(eveUsers => { if (eveUsers != null) this.callsByUser_selectedUsers.next(eveUsers); });

  }

  onExpand(template) {
    this.dialog.open(DialogComponent, {
      height: '75%',
      width: '75%',
      autoFocus: false,
      data: {
        header: "Calls",
        content: template
      }
    });
  }

  cradleToGraveNav() {
    //alert("hello!");
    this.router.navigate(['/', 'CradleToGravePage']);
  }

}





export interface AutoCompleteOption {
  name: string,
  value: any
}


var formatMillisecond = d3.timeFormat(".%L"),
  formatSecond = d3.timeFormat(":%S"),
  formatMinute = d3.timeFormat("%H:%M"),
  formatHour = d3.timeFormat("%H"),
  formatDay = d3.timeFormat("%a %d"),
  formatWeek = d3.timeFormat("%b %d"),
  formatMonth = d3.timeFormat("%B"),
  formatYear = d3.timeFormat("%Y");

function multiFormat(date) {
  return (d3.timeSecond(date) < date ? formatMillisecond
    : d3.timeMinute(date) < date ? formatSecond
      : d3.timeHour(date) < date ? formatMinute
        : d3.timeDay(date) < date ? formatHour
          : d3.timeMonth(date) < date ? (d3.timeWeek(date) < date ? formatDay : formatWeek)
            : d3.timeYear(date) < date ? formatMonth
              : formatYear)(date);
}
